import { render, staticRenderFns } from "./TestsDashboard.vue?vue&type=template&id=45947984&scoped=true&"
import script from "./TestsDashboard.vue?vue&type=script&lang=js&"
export * from "./TestsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45947984",
  null
  
)

export default component.exports